import actionTypes from '../constants/action-types';
import generateId from '../helpers/generate-id';

const addPageBinding = (pageId, binding) => ({
  type: actionTypes.ADD_BINDING,
  payload: { pageId, binding: { ...binding, id: generateId() } },
});

export default addPageBinding;
